// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "global.safe",
    name: "Safe",
    homepage: "https://safe.global/",
    image_id: "3913df81-63c2-4413-d60b-8ff83cbed500",
    app: {
        browser: "https://app.safe.global/",
        ios: "https://apps.apple.com/app/id1515759131",
        android: "https://play.google.com/store/apps/details?id=io.gnosis.safe",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "safe://",
        universal: "https://app.safe.global/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map